import { render, staticRenderFns } from "./HMSlug.vue?vue&type=template&id=bf4492f6&scoped=true&"
import script from "./HMSlug.vue?vue&type=script&lang=js&"
export * from "./HMSlug.vue?vue&type=script&lang=js&"
import style0 from "./HMSlug.vue?vue&type=style&index=0&id=bf4492f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4492f6",
  null
  
)

export default component.exports